export const columnsCsv = [
  { label: "Name", key: "name" },
  { label: " Code", key: "code" },
];

export const regColumnsCsv = [
  { label: "CT ID", key: "citizenId" },
  { label: "Type", key: "type" },
  { label: "Reg Type", key: "registrationType" },
  { label: "Date", key: "registrationDate" },
  { label: "Full Name", key: "fullName" },
  { label: "Mobile Number", key: "phoneNumber" },
  { label: "Branch ID", key: "branchId" },
  { label: "Company Name", key: "companyName" },
  { label: "Emirates ID", key: "emiratesId" },
  { label: "Card Serial Number", key: "cardSerialNo" },
];

export const options = [
  { value: "FullKYC", label: "Full  KYC" },
  { value: "PartialKYC", label: "Partial KYC" },
  { value: "NoKYC", label: "No KYC" },
  // { value: null, label: "None" },
];
export const options1 = [
  { value: "Passport", label: "Passport" },
  { value: "EID", label: "EmiratesId" },
  // { value: null, label: "None" },
];
